import React, { Component, useState } from "react";
import ErrorAlert from "../constantPages/Alerts/ErrorAlert";
import SuccessAlert from "../constantPages/Alerts/SuccessAlert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Navigate, withRouter } from "react-router-dom";
import UploadFileService from "../../services/UploadFileService";
import SocieteBox from "../../models/SocieteBox";
import BCService from "../../services/BCService";
// import Utils from "../../utils/Utils";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import FormErrors from "../constantPages/constants/FormErrors";
import CurrencyInput from "react-currency-input";
import SocieteService from "../../services/SocieteService";
import UtilsFormule from "../../utils/UtilsFormule";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import $ from "jquery";


class AddBCAchat extends Component {
  state = {
    formErrors: { name: '', value: '', description: '' },

    idBC: "",
    extrats: [], titleBill: "",
    sujet: "",
    descritptionFacture: "",
    refBC: "",
    yearRefBC: "",
    amountBC: "",
    tva: "",
    timbre: "",
    amountTT: "",
    echeanceDate: new Date(),
    selectedValue: "",
    selectedFile: null,
    societePartner: "",
    societeCliente: "",
    lieuLivraison: "",
    designation: "",
    // methodePayement: "",
    urlFile: "",
    buttonClickedRef: "",
    // urlFileImageBank: "",
    name: null,
    value: "",
    description: null,
    type: "row",
    placeholderValeur: "Montant",

    nameValid: false,
    valueValid: false,
    descriptionValid: false,

    formValid: false
  }

  constructor(props) {
    super(props);
    this.state = {
      formErrors: { name: '', value: '', description: '' },
      alert_message: "",
      alert_message_file: "",
      extrats: [],
      bankCard: [{ code: "", urlImage: "" }],
      cheque: [{ code: "", datePayement: "" }],
      echeances: [{ code: "", montant: "", datePayement: "" }],
      societePartner: "",
      societeCliente: "",
      lieuLivraison: "",
      designation: "",
      refBC: "",
      yearRefBC: "",
      buttonClickedRef: "",
      sujet: "",
      echeanceDate: new Date(),
      name: null,
      value: "",
      description: null,
      type: "row",
      placeholderValeur: "Montant",
      nameValid: false,
      valueValid: false,
      descriptionValid: false,
      formValid: false,
      redirect: false,

    };
    this.changeTitleBill = this.changeTitleBill.bind(this);
    this.changeAmountBC = this.changeAmountBC.bind(this);
    this.changeTva = this.changeTva.bind(this);
    this.changeTimbre = this.changeTimbre.bind(this);
    this.changeAmountTT = this.changeAmountTT.bind(this);
    this.changeEcheanceDate = this.changeEcheanceDate.bind(this);
    this.changeRefBill = this.changeRefBill.bind(this);
    this.changeYearRefBill = this.changeYearRefBill.bind(this);
    this.changeSujet = this.changeSujet.bind(this);
    this.changeLieuLivraison = this.changeLieuLivraison.bind(this);
    this.changeDesignation = this.changeDesignation.bind(this);
    this.onFileChangeHandler = this.onFileChangeHandler.bind(this);
    this.UploadFile = this.UploadFile.bind(this);
    this.saveBC = this.saveBC.bind(this);
    this.changeName = this.changeName.bind(this);
    this.changeDescription = this.changeDescription.bind(this);
    this.changeValeur = this.changeValeur.bind(this);
    this.handleChangeOptions = this.handleChangeOptions.bind(this);
  }
  addClick() {
    // this.setState({ selectedOption: null });
    // this.setState({ placeholderValeur: "Montant" });

    this.setState((prevState) => ({
      extrats: [
        ...prevState.extrats,
        {
          name: this.state.name,
          value: this.state.value,
          description: this.state.description,
          type: this.state.type,
        },
      ],
    }));
    this.setState({ name: "" });
    this.setState({ value: "" });
    this.setState({ description: "" });
    this.setState({ type: "row" });
    this.setState({ placeholderValeur: "Montant" });
    this.setState({ selectedOption: null });
    this.setState({ formValid: false });
    this.setState({ nameValid: false });
    this.setState({ valueValid: false });
    this.setState({ descriptionValid: false });
  }
  changeName(event) {
    this.setState({ name: event.target.value },
      () => { this.validateField("name", event.target.value) });
    // this.setState({ name: event.target.value });
  }

  changeDescription(event) {
    this.setState({ description: event.target.value },
      () => { this.validateField("description", event.target.value) });
    // this.setState({ description: event.target.value });
  }
  changeValeur(event) {
    this.setState({ value: event.target.value },
      () => { this.validateField("value", event.target.value) });
    // this.setState({ value: event.target.value });
  }
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let nameValid = this.state.nameValid;
    let descriptionValid = this.state.descriptionValid;
    let valueValid = this.state.valueValid;
    // case 'email':
    //   emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    //   fieldValidationErrors.email = emailValid ? '' : ' is invalid';
    //   break;
    // case 'password':
    //   passwordValid = value.length >= 6;
    //   fieldValidationErrors.password = passwordValid ? '': ' is too short';
    //   break;
    // default:
    //   break;
    switch (fieldName) {
      case 'name':
        nameValid = value.length >= 0;
        fieldValidationErrors.name = nameValid ? '' : 'titre vide';
        break;
      case 'description':
        descriptionValid = value.length >= 0;
        fieldValidationErrors.description = descriptionValid ? '' : 'description vide';
        break;
      case 'value':
        valueValid = value.length >= 0;
        fieldValidationErrors.value = valueValid ? '' : 'Montant vide';
        break;
      default:
        break;
    }
    this.setState({
      formErrors: fieldValidationErrors,
      nameValid: nameValid,
      descriptionValid: descriptionValid,
      valueValid: valueValid
    }, this.validateForm);
  }


  validateForm() {
    this.setState({ formValid: this.state.nameValid && this.state.valueValid && this.state.valueValid });
  }

  errorClass(error) {
    return (error.length === 0 ? '' : 'has-error');
  }

  handleChangeOptions = (selectedOption) => {

    this.setState({ type: selectedOption.value });
    if (selectedOption.value === "pa") {
      this.setState({ placeholderValeur: "Montant promo" });
    } else if (selectedOption.value === "pp") {
      this.setState({ placeholderValeur: "Pourcentage promo" });
    }
  };

  alertHandler(msg) {
    if (this.state.alert_message === "success") {
      return <SuccessAlert message="Bon de commande ajoutée avec succée" />;
    } else if (this.state.alert_message === "error") {
      return <ErrorAlert message="Oups!.. Une erreur est survenue" />;
    } else {
    }
  }
  alertHandlerFile(msg) {
    if (this.state.alert_message_file === "success") {
      return <SuccessAlert message="Bon de commande ajouté avec succée" />;
    } else if (this.state.alert_message_file === "error") {
      return (
        <ErrorAlert message="Oups!.. Une erreur est survenue lors de l'ajout du devis" />
      );
    } else {
    }
  }

  componentDidMount() {
    this.forceUpdate();
    SocieteService.getSocieteById(localStorage.getItem("idSociete"))
      .then((response) => {
        if (response.data["Societe"] === "vide") {
        } else {
          this.setState({ societeCliente: response.data["Societe"] });
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });

    SocieteService.getSocieteByIdUser(getCurrentUserId())
      .then((response) => {
        if (response.data["Societe"] === "vide") {
        } else {
          this.setState({ societePartner: response.data["Societe"] });
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });

    BCService.getRefBC()
      .then((response) => {
        if (response.data["RefBC"] === "vide") {
        } else {
          this.setState({ refBC: response.data["RefBC"].ref });
          this.setState({ yearRefBC: response.data["RefBC"].year });
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }

  changeYearRefBill(event) {
    this.setState({ yearRefBC: event.target.value });
  }
  changeRefBill(event) {
    this.setState({ refBC: event.target.value });
  }
  changeDesignation(event) {
    this.setState({ designation: event.target.value });
  }
  changeLieuLivraison(event) {
    this.setState({ lieuLivraison: event.target.value });
  }

  changeTitleBill(event) {
    this.setState({ titleBill: event.target.value });
  }
  changeSujet(event) {
    this.setState({ sujet: event.target.value });
  }

  changeTimbre(event) {
    this.setState({ timbre: event.target.value });
  }
  changeAmountBC(event) {
    this.setState({ amountBC: event.target.value });
  }
  changeTva(event) {
    this.setState({ tva: event.target.value });
  }

  changeAmountTT(event) {
    this.setState({ amountTT: event.target.value });
  }
  changeEcheanceDate(date) {
    this.setState({ echeanceDate: date });
  }

  testTypeValue(type, value) {


    if (type === "pp") {
      return <label>{value} %</label>;
    } else if (type === "pa") {
      return <label>-{value} DNT</label>;
    } else if (type === "row") {
      return <label>{value} DNT</label>;
    }
  }
  addExtratToView() {

    if (this.state.extrats.length === 0) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else if (
      this.state.extrats.length === 1 &&
      this.state.extrats[0]["name"] === "" &&
      this.state.extrats[0]["value"] === "" &&
      this.state.extrats[0]["description"] === ""
    ) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else {

      return (
        <div className="table-responsive">
          <table className="table table-striped">
            <tbody>
              {this.state.extrats.map((extrat, i) => (
                <tr className="text-center">
                  <td>{extrat.name}</td>
                  <td>{extrat.description}</td>
                  <td>{this.testTypeValue(extrat.type, extrat.value)}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-danger float-right"
                      onClick={() => this.removeExtrat(i)}                      >
                      <i class="fa fa-minus"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }

  removeExtrat(index) {
    var array = [...this.state.extrats];

    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ extrats: array });
    }
  }

  createUI() {
    const animatedComponents = makeAnimated();
    const { selectedOption } = this.state;
    const options = [
      { value: "row", label: "Tache" },
      { value: "pa", label: "Montant " },
      { value: "pp", label: "Pourcentage " },
    ];
    return (
      <div class="row">
        <FormErrors formErrors={this.state.formErrors} />
        <div class="col-md-3">
          <label>Titre: </label>
          <input
            value={this.state.name}
            onChange={this.changeName}
            className={`form-control ${this.errorClass(this.state.formErrors.name)}`}
            placeholder="Titre"
            required
          />
        </div>

        <div class="col-md-3">
          <label>Description: </label>
          <input
            value={this.state.description}
            onChange={this.changeDescription}
            className={`form-control ${this.errorClass(this.state.formErrors.description)}`}
            placeholder="Description"
          />
        </div>
        <div class="col-md-3">
          <label>Type </label>

          <Select
            value={this.state.selectedOption}
            closeMenuOnSelect={true}
            components={animatedComponents}
            options={options}
            onChange={this.handleChangeOptions}
            defaultValue={selectedOption}
            placeholder={"Tache"}
          />
        </div>
        <div class="col-md-3">
          <label>Valeur: </label>

          <CurrencyInput
            class={`form-control ${this.errorClass(this.state.formErrors.value)}`}
            precision="3"
            value={this.state.value}
            onChangeEvent={this.changeValeur}
          />
        </div>
      </div>
    );
  }

  handleChange(i, e) {
    const { name, value } = e.target;
    let extrats = [...this.state.extrats];
    extrats[i] = { ...extrats[i], [name]: value };
    this.setState({ extrats });
  }

  onFileChangeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      loaded: 0,
    });
  };

  UploadFile = () => {
    const dataFile = new FormData();
    dataFile.append("file", this.state.selectedFile);

    UploadFileService.uploadFileBill(dataFile)
      .then((res) => {
        this.setState({
          urlFile: res.data["Bill"],
        });
        this.setState({ alert_message_file: "success" });

      })
      .catch((error) => {
        this.setState({ alert_message_file: "error" });
      });
  };
  changeRef() {
    if (this.state.buttonClickedRef === "clicked") {
      return (
        <div class="row">
          <div class="col-md-6">
            <input
              value={this.state.refBC}
              onChange={this.changeRefBill}
              class="form-control"
              placeholder="Référence"
            />
          </div>
          <div class="col-md-6">
            <input
              value={this.state.yearRefBC}
              onChange={this.changeYearRefBill}
              class="form-control"
              placeholder="Année facture"
            />
          </div>
        </div>
      );
    }
  }
  changeDate() {
    if (this.state.buttonDateClicked === "clicked") {
      return (
        <div class="row">
          <div class="col-md-6">
            <label>Date de la commande: </label>
            <br />
          </div>

          <div class="col-md-6">
            <br />
            <DatePicker
              className="form-control"
              selected={this.state.echeanceDate}
              onChange={this.changeEcheanceDate}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={20}
              timeCaption="time"
              dateFormat="yyyy-MM-dd'T'HH:mm:ss"
            />
          </div>
        </div>
      );
    }
  }
  saveBC = (e) => {
    e.preventDefault();
    const dataFile = new FormData();
    dataFile.append("file", this.state.selectedFile);

    UploadFileService.uploadFileBill(dataFile)
      .then((res) => {

        this.setState({ alert_message_file: "success" });
        let BC = {
          idSociete: localStorage.getItem("idSociete"),
          idUserCreation: getCurrentUserId(),
          title: this.state.titleBill,
          sujet: this.state.sujet,
          refBC: this.state.refBC,
          yearRefBC: this.state.yearRefBC,
          amountBC: this.state.amountBC,
          tva: this.state.tva,
          timbre: this.state.timbre,
          amountTT: this.state.amountTT,
          commandeDate: this.state.echeanceDate,
          isPayed: "not_payed",
          cats: this.state.extrats,
          isIncome: localStorage.getItem("isIncome"),
          urlFile: res.data["Bill"],
          designation: this.state.designation,
          lieuLivraison: this.state.lieuLivraison,
        };
        console.log("BC", JSON.stringify(BC));
        BCService.addBC(BC)
          .then((response) => {
            if (response.data["BonCommande"] === "vide") {
              this.setState({ alert_message: "error" });
            } else {
              this.setState({ alert_message: "success" });
              this.setState({ idBC: response.data["BonCommande"]["id"] });
              localStorage.setItem("idBC", this.state.idBC);
              setTimeout(() => {
                this.setState({ redirect: true });
              }, 0);
            }
          })
          .catch((error) => {
            this.setState({ alert_message: "error" });
          });
        console.log(res.statusText);
      })
      .catch((error) => {
        this.setState({ alert_message_file: "error" });
      });
  };

  render() {
    $(".custom-file-input").on("change", function () {
      var fileName = $(this).val().split("\\").pop();
      $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
    });
    if (this.state.redirect) {
      return <Navigate replace to="/viewBCDetails" />;
    } else {
      return (
        <div class="content-wrapper" style={{ marginTop: "0" }}>
          <br />
          <section class="content">
            {this.alertHandler()}
            {this.alertHandlerFile()}
            <div class="row">
              <SocieteBox societe={this.state.societeCliente} role="cliente" />
              <SocieteBox societe={this.state.societePartner} />
            </div>

            <div class="row">
              <div class="col-md-12">
                <form class="form-horizontal" onSubmit={this.addBC}>
                  <div class="card card-dark">
                    <div class="card-header">
                      <h3 class="card-title">
                        Ajouter les informations du bon de commande:{" "}
                      </h3>
                    </div>

                    <div class="card-body">
                      <div className="row">
                        <div class="col-md-6">
                          <label>
                            Ref: {this.state.refBC}/{this.state.yearRefBC}
                          </label>
                        </div>
                        <div class="col-md-6">
                          <button
                            type="button"
                            className="btn btn-dark float-right"
                            onClick={() => {
                              this.setState({ buttonClickedRef: "clicked" });
                            }}
                          >
                            Autre référence
                          </button>
                        </div>
                      </div>
                      <br />
                      {this.changeRef()}
                      <br />
                      <div className="row">
                        <div class="col-md-6">
                          <label>
                            Date du bon de commande:{" "}
                            {UtilsFormule.formatDate(new Date())}
                          </label>
                        </div>
                        <div class="col-md-6">

                          <button
                            type="button"
                            className="btn btn-default float-right"
                            onClick={() => {
                              this.setState({ buttonDateClicked: "clicked" });
                            }}
                          >
                            Autre date
                          </button>
                        </div>

                      </div>
                      <br />


                      {this.changeDate()}

                      <div class="row">
                        <div class="col-md-4">
                          <label>Titre : </label>
                          <input
                            value={this.state.titleBill}
                            onChange={this.changeTitleBill}
                            class="form-control"
                            placeholder="Ajouter le titre"
                          />
                        </div>
                        <div class="col-md-4">
                          <label>Sujet : </label>
                          <input
                            value={this.state.sujet}
                            onChange={this.changeSujet}
                            class="form-control"
                            placeholder="Ajouter le sujet"
                          />
                        </div>

                        <div class="col-md-4">
                          <label>Lieu de livraison: </label>
                          <input
                            value={this.state.lieuLivraison}
                            onChange={this.changeLieuLivraison}
                            class="form-control"
                            placeholder="Ajouter le lieu de livraison "
                          />
                        </div>
                        {/* <div class="col-md-4">
                          <label>Date de la commande: </label>
                          <br />
                          <DatePicker
                            className="form-control"
                            selected={this.state.echeanceDate}
                            onChange={this.changeEcheanceDate}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={20}
                            timeCaption="time"
                            dateFormat="yyyy-MM-dd'T'HH:mm:ss"
                          />
                        </div> */}
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <label>Désignation: </label>

                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            style={{
                              width: "100%",
                              height: 100,
                              fontSize: 14,
                              lineHeight: 1,
                              border: "1px solid #dddddd",
                              padding: 10,
                            }}
                            value={this.state.designation}
                            onChange={this.changeDesignation}
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <label>Frais</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <label>Total HT: </label>
                          {/* <input
                          value={this.state.amountBC}
                          onChange={this.changeAmountBC}
                          class="form-control"
                          placeholder="Saisir le Total HT"
                        /> */}
                          <CurrencyInput
                            class="form-control"
                            precision="3"
                            value={this.state.amountBC}
                            onChangeEvent={this.changeAmountBC}
                          />
                        </div>
                        <div class="col-md-3">
                          <label>TVA: </label>
                          {/* <input
                          value={this.state.tva}
                          onChange={this.changeTva}
                          class="form-control"
                          placeholder="Saisir le TVA"
                        /> */}
                          <CurrencyInput
                            class="form-control"
                            precision="3"
                            value={this.state.tva}
                            onChangeEvent={this.changeTva}
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Timbre: </label>
                          {/* <input
                          value={this.state.timbre}
                          onChange={this.changeTimbre}
                          class="form-control"
                          placeholder="Saisir le timbre"
                        /> */}
                          <CurrencyInput
                            class="form-control"
                            precision="3"
                            value={this.state.timbre}
                            onChangeEvent={this.changeTimbre}
                          />
                        </div>

                        <div class="col-md-3">
                          <label>Total TTC: </label>
                          {/* <input
                          value={this.state.amountTT}
                          onChange={this.changeAmountTT}
                          class="form-control"
                          placeholder="Saisir le Total TTC"
                        /> */}
                          <CurrencyInput
                            class="form-control"
                            precision="3"
                            value={this.state.amountTT}
                            onChangeEvent={this.changeAmountTT}
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="exampleInputFile">Ajouter devis: </label>

                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  id="exampleInputFile"
                                  accept="application/pdf, .jpg, .jpeg, .png"
                                  type="file"
                                  className="custom-file-input"
                                  onChange={this.onFileChangeHandler}
                                />
                                <label className="custom-file-label" for="exampleInputFile">
                                  Entrer le devis
                                </label>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                </form>

                <div class="row">
                  <div class="col-md-12">
                    <div className="card card-dark">
                      <div className="card-header with-border">
                        <h3 className="card-title">Ajouter les tâches: </h3>
                      </div>
                      <div className="card-body">
                        {this.createUI()}
                        <br />
                        <button
                          type="button"
                          class="btn btn-dark float-right"
                          disabled={!this.state.formValid}

                          onClick={this.addClick.bind(this)}
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                      {this.addExtratToView()}

                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  onClick={this.saveBC}
                  class="btn btn-dark float-right"
                >
                  Ajouter
                </button>
                <br /> <br />
              </div>
            </div>
          </section>
        </div>
      );
    }
  }
}
export default AddBCAchat;
